export default function Purpose() {
  return (
     <section className="mx-auto max-w-6xl px-5 pt-12 pb-6 sm:px-8 sm:pt-16 sm:pb-8">
      <div className="flex flex-col items-center gap-6 rounded-[32px] bg-white px-7 py-8 shadow-[0_4px_20px_rgba(0,0,0,0.06)] border-2 border-slate-100/50 sm:flex-row sm:gap-8 sm:px-10 sm:py-8 lg:gap-10">
        
        {/* Icon */}
        <div className="flex h-24 w-24 shrink-0 items-center justify-center sm:h-32 sm:w-32">
          <img
            src="/img/about-us/trip-based.svg"
            alt="Travel companions"
            className="h-20 w-20 object-contain sm:h-28 sm:w-28"
          />
        </div>

        {/* Content */}
        <div className="space-y-4 text-slate-700 text-center sm:text-left">
          <p className="text-sm leading-relaxed sm:text-base lg:text-[15px]">
            We believe solo travel should never mean traveling alone. Whether
            you're looking to share experiences, split travel costs, explore new
            places together, or simply have someone to accompany you on your
            journey, SoloConnect makes it easier to find compatible travel
            companions.
          </p>

          <p className="text-sm leading-relaxed sm:text-base lg:text-[15px]">
            Unlike traditional social or dating platforms, SoloConnect focuses
            exclusively on{" "}
            <span className="font-semibold text-[#7209B7]">
              trip-based connections
            </span>
            . Every interaction begins with a shared travel plan, helping
            travelers connect with a common purpose.
          </p>
        </div>
      </div>
    </section>
  );
}
